require('./areas-list-container.scss')

module.exports = {
  template: require('./areas-list-container.pug')()
  controller: require('./areas-list-container.ctrl')
  bindings:
    country: '<'
    city: '<'
}
